export function deviceSelector(state = {}) {
  return state.device || {};
}
